import { MijnRoute } from '../../mijn-navigatie.model';

export const PENSION_EXPANSION_REQUEST_INVESTMENT: MijnRoute = {
    path: 'pensioen-uitbreiding-aanvragen/beleggen',
    navigationEvent: 'toPensionExpansionRequestInvestment',
    regex: /^\/pensioen-uitbreiding-aanvragen\/beleggen$/,
    webcomponent: 'my-pension-expansion-request-webcomponent'
};
